import React from 'react';

import S from './Weather.module.css';

export const WeatherImg = () => (
  <div className={S.root}>
    <div className={S.light}>
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
    </div>
    <div className={S.sun}></div>
    <div className={S.num}>
      23<sup>o</sup>
    </div>
  </div>
);
